import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../components/MainBody/MainBody";
import MainTabList from "../../components/MainBody/MainTabList";
import { useTrust } from "../../lib/context/TrustContext";
import EditTrust from "./EditTrust";
import Integration from "./Integrations/Integration";
import TemplateSettings from "./TemplateSettings/TemplateSettings";
import WithdrawalAccount from "./WithdrawalAccount";

const tabsKey = [
  {
    name: "Trust Settings",
    tabName: "trust",
    value: 1,
  },
  {
    name: "General / Withdrawal Account",
    tabName: "withdrawal-account",
    value: 4,
  },
  {
    name: "Integration",
    tabName: "integration",
    value: 2,
  },
  {
    name: "Template Settings",
    tabName: "template",
    value: 3,
  },
];

const TrustGeneralSetting = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "trust";
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);
  const navigate = useNavigate();

  const { trustId } = useTrust();

  useEffect(() => {
    navigate(
      `/trusts/${trustId}/trust-general-settings?tab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      }
    );
  }, [activeTab, navigate, trustId]);

  useEffect(() => {
    setActiveTab(tabsKey?.find((item) => item?.tabName === selectedTab)?.value);
  }, [selectedTab]);

  return (
    <>
      <MainBody search={false} loading={false}>
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={`bg-background relative ${activeTab === 2 ? "p-0" : ""}`}
        >
          {activeTab === 1 ? (
            <EditTrust />
          ) : activeTab === 2 ? (
            <Integration />
          ) : activeTab === 3 ? (
            <TemplateSettings />
          ) : activeTab === 4 ? (
            <WithdrawalAccount />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default TrustGeneralSetting;
